











































import { Component, Vue, Prop } from 'vue-property-decorator';

export type BreadcrumbData = {
  path?: string;
  label: string;
  onClick?(): void;
};

@Component({})
export default class Breadcrumbs extends Vue {
  @Prop() gaTitle?: string;
  @Prop({ default: () => [] }) breadcrumbs!: BreadcrumbData[];

  isLastItem(index: number) {
    return index === this.breadcrumbs.length - 1;
  }

  gotoPath(path?: string) {
    if (!path) return;

    this.$router.push(path);
  }

  handleBreadcrumbClick({ label, onClick }: BreadcrumbData) {
    if (onClick) onClick();
    if (this.gaTitle) {
      this.$analytics({
        eventCategory: this.gaTitle,
        eventAction: 'click',
        eventLabel: `Clicked on "${label}"`
      });
    }
  }
}
